import { AcademicCapIcon } from "@heroicons/react/24/outline";
import { CircleSlash } from "lucide-react";
import { cn } from "@/lib/utils";
import type { RecordAccountStatus } from "./record-account-status";
import statusActiveIcon from "./status-active-icon.svg";

const STATUS_LABEL: Record<RecordAccountStatus, string> = {
  active: "Active",
  deactivated: "Deactivated",
  in_training: "In Training",
};

export function RecordStatusBadge({ status }: { status: RecordAccountStatus }) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-[10px] py-[2px] font-body text-[12px] font-medium leading-4",
        status === "deactivated" && "bg-[#dcdcdc] text-[#525252]",
        status === "active" && "bg-[#d0fae5] text-[#006045]",
        status === "in_training" && "bg-[#b8f1ff] text-[#005b76]",
      )}
    >
      {status === "active" ? (
        <img src={statusActiveIcon} alt="" width={12} height={12} />
      ) : status === "in_training" ? (
        <AcademicCapIcon className="size-3 shrink-0" />
      ) : (
        <CircleSlash className="size-3 shrink-0" />
      )}
      {STATUS_LABEL[status]}
    </div>
  );
}
